<template>
  <section class="text-left tour-guide h-full clearfix w">
    <div class="text-center content-title">
      <span class="inline-block line-css"></span>
      <span class="font-css"> <span>游览信息</span> TOUR INFORMATION</span>
      <span class="inline-block line-css"></span>
    </div>
    <div class="tour-guide-box clearfix">
      <div class="tour-guide-left w-1/3 float-left">
        <div class="clearfix">
          <span class="float-left tour-title cursor-default"
            >概况&nbsp;OVERVIEW</span
          >
          <div
            class="more float-right"
            @click="
              link({
                type: 'catalogue',
                category: 'tour'
              })
            "
          >
            更多 | MORE
          </div>
        </div>
        <div v-if="homeInformation">
          <HtmlViewer
            class="tour-guide-content cursor-default overflow-hidden"
            :emptyText="'暂无数据'"
            :content="homeInformation"
          ></HtmlViewer>
        </div>
      </div>
      <div class="w-2/3 h-full float-right relative tour-guide-right">
        <div class="clearfix">
          <span class="float-left tour-title cursor-default cursor-defaulte"
            >订票入口&emsp;BOOKING ENTRY</span
          >
        </div>
        <BookingOffice type="small" class="bg-flower"></BookingOffice>
      </div>
    </div>
  </section>
</template>

<script>
import link from '@/core/mixins/link'
import BookingOffice from '@/components/home/BookingOffice'
import HtmlViewer from '@/components/common/HtmlViewer'
export default {
  name: 'tours-nav',
  components: {
    BookingOffice,
    HtmlViewer
  },
  props: {},
  mixins: [link],
  data() {
    return {}
  },
  computed: {
    homeInformation() {
      let data = this.$store.getters['HomeStore/homeInformation']
      return data
    }
  },
  watch: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.tour-title {
  font-size: 22px;
  line-height: 38px;
  margin-bottom: 35px;
}
.tour-guide {
  color: $c-white;

  .tour-guide-box {
    min-height: 500px;
    background-color: $c-tour-bg-blue;
    background-image: url('../../../static/images/tour/bg-flower-b.png');
    background-repeat: no-repeat;
    background-size: auto 400px;
    background-position: 220px 210px;
  }
  .tour-guide-left {
    // height: 500px;

    padding: 22px 25px;
    .tour-guide-title {
      font-size: 23px;
      padding-bottom: 10px;
    }
    .tour-guide-content {
      margin-bottom: 20px;
      line-height: 1.8;
    }
    ::v-deep  .tour-guide-describe {
      line-height: 2.2;
      font-size: 14px;
      padding-bottom: 90px;
    }
    ::v-deep  .tour-guide-route {
      li {
        line-height: 24px;
        font-size: 14px;
        padding-bottom: 12px;
        padding-left: 56px;
        position: relative;
        &:last-child {
          padding-bottom: 0px;
        }
        span {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 39px;
          height: 37px;
          background-repeat: no-repeat;
          background-size: contain;
          background-image: url('../../../static/images/home/bus-icon.png');
        }
        &:nth-child(2) {
          span {
            top: -2px;
            width: 46px;
            height: 26px;
            background-image: url('../../../static/images/home/ticket-time-icon.png');
          }
        }
        &:nth-child(3) {
          span {
            top: 6px;
            width: 43px;
            height: 21px;
            background-image: url('../../../static/images/home/ticket-icon.png');
          }
        }
      }
    }
    .more {
      bottom: 15px;
      left: 30px;
      margin-left: 0;
    }
  }
  .tour-guide-right {
    // height: 500px;
    padding: 30px 0 50px 26px;
    background-color: $c-tour-0;
    .tour-title {
      line-height: 1;
      margin-bottom: 50px;
    }
    .more {
      margin-right: 20px;
    }
  }
}
.bg-flower {
  background-image: url('../../../static/images/tour/bg-flower-b.png');
  background-repeat: no-repeat;
  background-size: auto 360px;
  background-position: 0px 0px;
}
</style>
